export default Object.freeze({
    LANGUAGES: ['en', 'fr']
})